import { useEffect } from 'react';

const SITE_NAME = 'Salvador Eyewear';

function upsertMeta(attr, key, content) {
  const tag = document.querySelector(`meta[${attr}="${key}"]`);
  // A blank value on THIS page must not leave the PREVIOUS page's tag
  // sitting there unchanged after an SPA navigation — that reads to a
  // crawler as this page describing something else entirely. Clear it
  // instead of skipping; only skip creating a brand-new empty tag.
  if (!content) { if (tag) tag.setAttribute('content', ''); return; }
  if (tag) { tag.setAttribute('content', content); return; }
  const created = document.createElement('meta');
  created.setAttribute(attr, key);
  created.setAttribute('content', content);
  document.head.appendChild(created);
}

function upsertLink(rel, href) {
  if (!href) return;
  let tag = document.querySelector(`link[rel="${rel}"]`);
  if (!tag) {
    tag = document.createElement('link');
    tag.setAttribute('rel', rel);
    document.head.appendChild(tag);
  }
  tag.setAttribute('href', href);
}

// Sets document.title + the meta description/keywords/canonical/OG tags a
// crawler actually reads — nothing else in the storefront does this except
// the 3 landing pages, which is why Google/Bing only ever saw one generic
// title for every category, product and search-result page. Call once per
// page with whatever SEO fields that page has (falls back sensibly when a
// field is blank, since most existing categories/products predate SEO fields
// being editable at all).
export default function useSEO({ title, description, keywords, image, canonical }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    document.title = fullTitle;
    upsertMeta('name', 'description', description);
    upsertMeta('name', 'keywords', keywords);
    upsertMeta('property', 'og:title', fullTitle);
    upsertMeta('property', 'og:description', description);
    if (image) upsertMeta('property', 'og:image', image);
    upsertMeta('property', 'og:type', 'website');
    if (canonical) upsertLink('canonical', canonical);
  }, [title, description, keywords, image, canonical]);
}
